import React from 'react';
import ReactECharts from 'echarts-for-react';

const MultiLineCycles = (props) => {
  // Extraer todas las fechas únicas para usar como eje X
  const allMonths = Array.from(
    new Set(props.data.flatMap(item => item.data.map(d => d.month)))
  ).sort();

  // Función para formatear números con puntos de miles
  const formatNumber = (value) => {
    if (value === null || value === undefined) return '';
    return value.toLocaleString('es-CO'); // Usa el locale español que pone puntos para miles
  };

  // Construir series para ECharts
  const series = props.data.map(section => ({
    name: section.name,
    type: 'line',
    smooth: true,
    label: {
      show: true,
      position: 'top',
      formatter: (params) => formatNumber(params.value) // Formatea el valor
    },
    data: allMonths.map(month => {
      const point = section.data.find(d => d.month === month);
      return point ? point.value : null;
    })
  }));

  const options = {
    title: {
      text: props.title || 'Título del gráfico',
      subtext: props.subTitle || '',
      left: 'center',
      top: 10
    },
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        // params es un array con los datos de todas las series en ese punto
        let result = `${params[0].axisValue}<br/>`;
        params.forEach(param => {
          if (param.value !== null) {
            result += `${param.marker} ${param.seriesName}: ${formatNumber(param.value)}<br/>`;
          }
        });
        return result;
      }
    },
    legend: {
      data: props.data.map(item => item.name),
      left: 'center',
      top: 'bottom'
    },
    xAxis: {
      type: 'category',
      data: allMonths
    },
    yAxis: {
      type: 'value',
      name: props.labelY,
      axisLabel: {
        formatter: (value) => formatNumber(value) // Formatea los valores del eje Y
      }
    },
    series
  };

  return <ReactECharts
    option={options}
    notMerge={true} 
    style={{ height: '400px' }}
    ref={props.chartRef}
  />;
};

export default MultiLineCycles;